import { render, staticRenderFns } from "./ManageProduct365.vue?vue&type=template&id=1556ecef&"
import script from "./ManageProduct365.vue?vue&type=script&lang=js&"
export * from "./ManageProduct365.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports